import { Cable } from '../types';

/** Drop duplicate ids (keep the first). Same-id rows confuse React keys and delete-by-id. */
export function uniqueCablesById(cables: Cable[] | undefined | null): Cable[] {
  if (!cables?.length) return [];
  const seen = new Map<string, Cable>();
  for (let i = 0; i < cables.length; i++) {
    const cable = cables[i];
    if (!cable?.id || seen.has(cable.id)) continue;
    seen.set(cable.id, cable);
  }
  return Array.from(seen.values());
}

export function sameCableEndpoints(
  aFrom: string,
  aTo: string,
  bFrom: string,
  bTo: string
): boolean {
  return (aFrom === bFrom && aTo === bTo) || (aFrom === bTo && aTo === bFrom);
}

export function findCableBetween(
  cables: Cable[] | undefined | null,
  fromId: string,
  toId: string
): Cable | undefined {
  return uniqueCablesById(cables).find((c) => sameCableEndpoints(c.from, c.to, fromId, toId));
}

export function cableUsesEndpoint(cable: Cable, endpointId: string): boolean {
  return cable.from === endpointId || cable.to === endpointId;
}

export function upsertCable(cables: Cable[], cable: Cable): Cable[] {
  const unique = uniqueCablesById(cables);
  const index = unique.findIndex((c) => c.id === cable.id);
  if (index === -1) return [...unique, cable];
  const next = unique.slice();
  next[index] = { ...unique[index], ...cable };
  return next;
}
